import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../login/login.css";
import Header from "../../components/header/Header";
import Subscribe from "../../components/subscribe/Subscribe";
import Footer from "../../components/footer/Footer";
import { baseURL } from "../../constants/url";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function ResetPassword() {
  const [formData, setFormData] = useState({
    email: "",
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  const emailFromState = location.state?.email;

  // Autofill email or redirect
  useEffect(() => {
    if (emailFromState) {
      setFormData((prev) => ({ ...prev, email: emailFromState }));
    } else {
      setMessage("No email found. Redirecting...");
      setTimeout(() => navigate("/forgotpassword"), 2000);
    }
  }, [emailFromState, navigate]);

  // Floating label fix
  useEffect(() => {
    const inputs = document.querySelectorAll("input");
    inputs.forEach((input) => {
      const toggleFilled = () => {
        if (input.value.trim() !== "") {
          input.classList.add("filled");
        } else {
          input.classList.remove("filled");
        }
      };

      toggleFilled();
      input.addEventListener("input", toggleFilled);

      return () => input.removeEventListener("input", toggleFilled);
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  //  Validation
  const validate = () => {
    const newErrors = {};
    const { new_password, confirm_password } = formData;

    if (!new_password.trim()) {
      newErrors.new_password = "New password is required.";
    } else if (new_password.length < 6) {
      newErrors.new_password = "Password must be at least 6 characters.";
    }

    if (!confirm_password.trim()) {
      newErrors.confirm_password = "Confirm password is required.";
    } else if (new_password.trim() !== confirm_password.trim()) {
      newErrors.confirm_password = "Passwords do not match.";
    }

    return newErrors;
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    setMessage("");

    try {
      const response = await fetch(`${baseURL}common/reset_password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: formData.email,
          new_password: formData.new_password,
          confirm_password: formData.confirm_password,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Password reset successful! Redirecting to login...");
        setTimeout(() => navigate("/login"), 1500);
      } else {
        setMessage(data.message || "Reset failed. Please try again.");
      }
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const passwordsMatch =
    formData.new_password &&
    formData.confirm_password &&
    formData.new_password === formData.confirm_password;

  return (
    <>
      <Header />

      <div className="container-fluid login_bg">
        <div className="formContainer_box">
          <div className="formContainer">
            <div className="signInContainer">
              <h4 className="form_title pt_20 pb_20 mb_20">Reset New Password</h4>

              <form className="pb_30" onSubmit={handleResetPassword}>
                <input type="hidden" name="email" value={formData.email} />

                {/* New Password */}
                <div className="inputSection">
                  <input
                    type={showNewPassword ? "text" : "password"}
                    name="new_password"
                    className="userName"
                    value={formData.new_password}
                    onChange={handleChange}
                  />
                  <label className="inputLabel">New Password</label>
                  <span
                       className="togglePassword"
                        onClick={() => setShowNewPassword(!showNewPassword)}
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "36%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </span> 
                  {errors.new_password && (
                    <p className="formError">{errors.new_password}</p>
                  )}
                </div>

                {/* Confirm Password */}
                <div className="inputSection">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirm_password"
                    className="password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                  />
                  <label className="inputLabel">Confirm Password</label>
                  <span
                       className="togglePassword"
                    onClick={() =>
                      setShowConfirmPassword(!showConfirmPassword)
                    }
                      style={{
                        position: "absolute",
                        right: "10px",
                        top: "54%",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                      }}
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </span>
                  
                  {errors.confirm_password && (
                    <p className="formError">{errors.confirm_password}</p>
                  )}
                

                {formData.confirm_password && !passwordsMatch && (
                  <label className="formError" style={{ fontSize: 12 }}>Passwords do not match.</label>
                )}
                </div>

                {message && <p className="formMessage">{message}</p>}

                <button
                  className="saveForm"
                  type="submit"
                  disabled={
                    loading ||
                    !formData.email ||
                    !passwordsMatch ||
                    formData.new_password.length < 6
                  }
                >
                  {loading ? "Resetting..." : "Reset Password"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <Subscribe />
      <Footer />
    </>
  );
}
